import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { Presentation } from '../../../core/gameflow/controller/Presentation';
import { Beheaded } from '../../Beheaded';
import { SoundConfig } from '../../config/sound/SoundConfig';
import { GameData } from '../../server/data/GameData';
import { InitData } from '../../server/data/InitData';

export class SoulWildResultPresentation extends Presentation {
    private currentWinMultiplier: number;

    private _showSWStep: number = 0;
    private noWin: boolean;

    private swSize: number;
    private posTopLeftSW: { reel: number; row: number };
    private wasFirstStepSkipped: boolean = false;

    private freeSpinsLeft: number;

    public setGamedData(data: GameData): void {
        this.currentWinMultiplier = data.currentWinMultiplier;

        this.posTopLeftSW = data.Reel.fetchTopLeftSWPosition;
        this.swSize = data.Reel.SWSize;
        this.noWin = !data.Win.singleWin;

        
        this.freeSpinsLeft = data.raw.freespinsLeft;
        if(data.currentLevel < data.nextLevel) this.freeSpinsLeft -= ((data.nextLevel - data.currentLevel)*2);
        if(data.nextLevel != data.currentLevel && data.nextLevel == 5) this.freeSpinsLeft -= 4;
    }

    public preStart(): void {
        this._showSWStep = 0;
    }

    public checkForActivation(data: GameData): boolean {
        return data.Reel.SWSize > 0;
    }

    public createPresentation(enableSkip: Function): void {
        this.timeline.add(() => {
            enableSkip(true);
        });

        if (!this._showSWStep) {
            this.timeline.add(() => {
                Beheaded.souldWildController.deactivateIndicators();
            });
            this.timeline.add(Beheaded.souldWildController.soulWildLand(this.posTopLeftSW, this.swSize));
            this.timeline.add(() => {
                SlotGame.keypadPlugin.setZeroBetSpinCounter(this.freeSpinsLeft ? this.freeSpinsLeft : -1);

            },"-=1.5")
            this._showSWStep = 1;
        } else {
            if(this.swSize == 1 && Beheaded.baseMultiplier.currentMult == 1 && Beheaded.baseMultiplier.currentMult == 1){
                this.timeline.add(Beheaded.souldWildController.killSoulWild());
            }else{
                this.timeline.add(Beheaded.souldWildController.applySoulWildToMult(this.swSize, this.noWin));

                if (this.currentWinMultiplier > 1 && this.swSize > 1) {

                    this.timeline.add(
                        Beheaded.counter.displayMult(this.currentWinMultiplier),
                        '-=0.2'
                    );
                }
            }

            this.PresentationState.setInactive();
            this._showSWStep = 2;
        }
    }

    public skip(): void {
        if (this._showSWStep === 1) {
            this.wasFirstStepSkipped = true;
            Beheaded.soundPlayer.fadeSound(SoundConfig.SHAKE_SYMBOLS, 1, 0, 200);
            Beheaded.soundPlayer.stopSound(SoundConfig.WILD_SIZE_ACTIVE[this.swSize-1]);
            Beheaded.soundPlayer.playSound(SoundConfig.WILD_SIZE_CHANT[this.swSize-1]);
        } else if (this._showSWStep === 2) {
            if (this.wasFirstStepSkipped) {
                Beheaded.soundPlayer.fadeSound(SoundConfig.WILD_SIZE_CHANT[this.swSize-1], 1, 0, 200);
            } else {
                Beheaded.soundPlayer.fadeSound(SoundConfig.WILD_SIZE_ACTIVE[this.swSize-1], 1, 0, 200);
            }
        }
        super.skip();
    }
}
